import { useState } from 'react';
import FormModal from '../FormTag/FormModal';
import DragAndDropLayout from '../../Layout/DragAndDropLayout';
import FormButton from './FormButton';

interface IDragAndDropButton {
  buttonName?: string;
  buttonClassName?: string;
  title?: string;
  acceptableFiles: any;
  dragAndDropModalMessage?: string
  forCrop: boolean;
  data?: any;
  multiple?: boolean;
  show?: boolean
  // buttonFunction?: () => void;
  onModaCancel?: (data:boolean) => any;
}

const DragAndDropButton = (props: IDragAndDropButton) => {
  const { buttonName, forCrop, buttonClassName, title = '', acceptableFiles, dragAndDropModalMessage = '', data, multiple = false,onModaCancel } = props

  const [show, setShow] = useState(false)
  const handleClose = () => {
    setShow(false)
    onModaCancel?.(true);
  }
  const handleOpen = () => {
    setShow(true)
  }

  

  const footer = (
    <>
      {
        !forCrop ? <div className="my-2 bg-white rounded d-flex justify-content-center">
          <div>
            <FormButton
              className="sph-btn sph-shift me-2"
              handleClick={handleClose}
            >
              Cancel
            </FormButton>
          </div>
          <FormButton className="sph-btn me-2" handleClick={handleClose}>
            Submit
          </FormButton>
        </div> : null
      }

    </>
  );

  return (
    <>
      <button type='button' className={buttonClassName} onClick={handleOpen}>{buttonName}</button>
      <FormModal 
        show={show}
        handleClose={handleClose}
        modalSize='lg'
        footer={footer}
        modalTitle={title}
        customClassName="drag-and-drop-modal"
      >
        <DragAndDropLayout 
          data={data}
          acceptableFiles={acceptableFiles}
          dragAndDropModalMessage={dragAndDropModalMessage}
          forCrop={forCrop}
          multiple={multiple}
          handleClose={handleClose}
        />
      </FormModal>
    </>

  )


}

export default DragAndDropButton